import {
  CLEAR_DEPARTURE_TIME_FILTER,
  SET_DIRECTNESS_FILTER_ENABLED,
  SET_INITIAL_DIRECTNESS_FILTER,
  TOGGLE_DEPARTURE_TIME_FILTER,
} from '../helpers/constants/actionsConstants';

import type {
  ClearDepartureTimeFilterAction,
  SetDirectnessFilterEnabledAction,
  SetInitialDirectnessFilterAction,
  ToggleDepartureTimeFilterAction,
} from './types';
import type { DepartureTime } from '../helpers/constants/departureTimeConstants';

const setInitialDirectnessFilter = (
  filtering: boolean,
): SetInitialDirectnessFilterAction => ({
  type: SET_INITIAL_DIRECTNESS_FILTER,
  payload: filtering,
});

const setDirectnessFilterEnabled = (
  enabled: boolean,
): SetDirectnessFilterEnabledAction => ({
  type: SET_DIRECTNESS_FILTER_ENABLED,
  payload: enabled,
});

// Multi-select chips: adds the bucket if unselected, removes it if already selected.
const toggleDepartureTimeFilter = (
  bucket: DepartureTime,
): ToggleDepartureTimeFilterAction => ({
  type: TOGGLE_DEPARTURE_TIME_FILTER,
  payload: bucket,
});

// Resets every bucket to unselected (e.g. single-select 'Anytime', or a multi-select 'clear all').
const clearDepartureTimeFilter = (): ClearDepartureTimeFilterAction => ({
  type: CLEAR_DEPARTURE_TIME_FILTER,
});

export {
  setInitialDirectnessFilter,
  setDirectnessFilterEnabled,
  toggleDepartureTimeFilter,
  clearDepartureTimeFilter,
};
